import { riderInitialState } from "./InitialState";
import { IActionType } from "../../interfaces/Index";
import * as actionTypes from "../actionTypes/Index";
import { IFetchRiderActionResponse } from "../../interfaces/riderManagement.interface";

const initialState = { ...riderInitialState };

export const appendUpdateRiders = (
  payload: IFetchRiderActionResponse,
  state: any
) => {
  if (payload.isPaginatedRes) {
    return [...state.riders, ...payload.riderManagementData];
  }
  return payload.riderManagementData.slice();
};

export default function riderManagementReducer(
  state = initialState,
  action: IActionType
) {
  switch (action.type) {
    case actionTypes.CREATE_RIDER_MANAGEMENT_USERS_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        isRiderManagementUserAdded: false,
      });
    }

    case actionTypes.CREATE_RIDER_MANAGEMENT_USERS_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isRiderManagementUserAdded: true,
      });
    }

    case actionTypes.CREATE_RIDER_MANAGEMENT_USERS_FAIL: {
      return Object.assign({}, state, {
        isRiderManagementUserAdded: false,
        isLoading: false,
        isError: true,
        error: action.error,
      });
    }

    case actionTypes.CREATE_RIDER_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isRiderCreated: false,
        isError: false,
      });
    }

    case actionTypes.CREATE_RIDER_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isRiderCreated: true,
      });
    }

    case actionTypes.CREATE_RIDER_FAIL: {
      return Object.assign({}, state, {
        isError: true,
        error: action.error,
        isRiderCreated: false,
        isLoading: false,
      });
    }

    case actionTypes.GET_RIDER_MANAGEMENT_LIST_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        isRiderListFetched: false,
        isRiderManagementUserAdded: false,
        isRiderUpdated: false,
        riders: null,
        error: null,
      });
    }

    case actionTypes.GET_RIDER_MANAGEMENT_LIST_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isRiderListFetched: true,
        isRiderUpdated: false,
        isRiderCreated: false,
        riders: appendUpdateRiders(
          action.payload as IFetchRiderActionResponse,
          state
        ),
        pagination: (action.payload! as any).pagination,
      });
    }

    case actionTypes.GET_RIDER_MANAGEMENT_LIST_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isRiderListFetched: false,
        isError: true,
        error: action.error,
      });
    }

    case actionTypes.GET_RIDER_USER_DETAIL_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        isRiderUserDetailsFetched: false,
        riderUserDetails: null,
        error: null,
      });
    }
    case actionTypes.GET_RIDER_USER_DETAIL_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: false,
        isRiderUserDetailsFetched: true,
        isRiderCreated: false,
        riderUserDetails: action.payload,
      });
    }
    case actionTypes.GET_RIDER_USER_DETAIL_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        isRiderUserDetailsFetched: false,
        error: action.error,
      });
    }

    case actionTypes.UPDATE_RIDER_MANAGEMENT_USER_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        isRiderUpdated: false,
        error: null,
      });
    }

    case actionTypes.UPDATE_RIDER_MANAGEMENT_USER_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: false,
        isRiderUpdated: true,
        error: null,
      });
    }

    case actionTypes.UPDATE_RIDER_MANAGEMENT_USER_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        isRiderUpdated: false,
        error: action.error,
      });
    }

    case actionTypes.DOWNLOAD_LOCUS_PLAN_CSV_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        error: null,
        isCsvDownloaded: false,
        locusCsvFile: null,
      });
    }

    case actionTypes.DOWNLOAD_LOCUS_PLAN_CSV_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isCsvDownloaded: true,
        locusCsvFile: action.payload,
      });
    }

    case actionTypes.DOWNLOAD_PLAN_OUTPUT_CSV_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
      });
    }

    case actionTypes.DOWNLOAD_LOCUS_PLAN_CSV_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        error: action.error,
        isCsvDownloaded: false,
        locusCsvFile: null,
      });
    }

    case actionTypes.GET_RIDER_JOB_TYPES_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        riderTypes: {
          jobTypes: [],
          subTypes: [],
        },
        error: null,
      });
    }
    case actionTypes.GET_RIDER_JOB_TYPES_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: false,
        riderTypes: action.payload,
      });
    }
    case actionTypes.GET_RIDER_JOB_TYPES_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        error: action.error,
      });
    }

    default:
      return state;
  }
}
